// Copyright (C) Konrad Gadzinowski

export const HOSTED_APP_BODY_CLASS = "hosted-app"
